import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const ProjectsView = () => import('@/views/ProjectsView.vue');
const ProjectsIndexView = () => import('@/views/projects/IndexView.vue');
const ProjectsNewView = () => import('@/views/projects/NewView.vue');
const ProjectsSuccessView = () => import('@/views/projects/SuccessView.vue');
const ProjectsFailedView = () => import('@/views/projects/FailedView.vue');
export const NAME_PROJECTS = 'Projects';
export const NAME_PROJECTS_INDEX = 'ProjectsIndex';
export const NAME_PROJECTS_NEW = 'ProjectsNew';
export const NAME_PROJECTS_SUCCESS = 'ProjectsSuccess';
export const NAME_PROJECTS_FAILED = 'ProjectsFailed';
export const PATH_PROJECTS = '/projects';

const children = [
  { path: '', component: ProjectsIndexView, name: NAME_PROJECTS_INDEX },
  { path: 'new', component: ProjectsNewView, name: NAME_PROJECTS_NEW, meta: { dataLoaders: ['new_project_session', 'products_and_prices'] } },
  { path: 'success', component: ProjectsSuccessView, name: NAME_PROJECTS_SUCCESS },
  { path: 'failed', component: ProjectsFailedView, name: NAME_PROJECTS_FAILED },
];

export const route: DiscoveredRouteModule = {
  id: 'root.projects',
  scope: 'root',
  name: NAME_PROJECTS,
  path: PATH_PROJECTS,
  component: ProjectsView,
  // Hide Projects entirely on private_label
  meta: { requiresAuth: true, onlyWhiteLabel: true },
  children,
};
